// extracted by mini-css-extract-plugin
module.exports = {"body":"ErrorCard_body__2Xo51","status":"ErrorCard_status__3_KxK"};